import { Component } from '@angular/core';

import { combineLatest, map, Observable } from 'rxjs';

import { ChaptersClient } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { ProjectStateService } from 'content-manager/src/app/projects/project/project-state.service';

interface IProjectThemasViewModel {
    isReadonly: boolean;
    hasChapters: boolean;
}

@Component({
    templateUrl: './project-themas.component.html',
    standalone: false
})
export class ProjectThemasComponent {

    public readonly viewModel$: Observable<IProjectThemasViewModel>;

    constructor(
        projectStateService: ProjectStateService,
        chaptersClient: ChaptersClient) {

        this.viewModel$ = combineLatest([
            projectStateService.model$,
            projectStateService.switchMap(project => chaptersClient.hasChapters(project.id))])
            .pipe(map(([project, hasChapters]) => ({
                isReadonly: project.isReadonly,
                hasChapters
            })));
    }
}
